import { makeStyles } from '@material-ui/core/styles';

const itemShareStyle = makeStyles(() => ({
	tooltipPanel: {
		padding: '16px',
		width: 240,
		zIndex: 1,
		pointerEvents: 'auto'
	},
	tooltipText: {
		display: 'inline-block',
		fontFamily: 'Bogle-Medium',
		fontSize: '12px',
		paddingRight: '2.5px'
	},
	underlineText: {
		fontFamily: 'Bogle-Medium',
		fontSize: '12px',
		textDecorationLine: 'underline',
		zIndex: 2,
		paddingRight: '3px',
		'&:hover': {
			cursor: 'pointer'
		}
	}
}));

export default itemShareStyle;
